import { Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectShortFridgeId } from "slices/fridgeInfoSlice";
import { logToSentry } from "utils/logger";

import ErrorModalImage from "assets/illustrations/errorModalImage.svg";
import { ModalContentWrapper } from "components/primitives/ModalContentWrapper";
import { ModalTitle } from "components/primitives/ModalTitle";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";

import { BasicModal } from "./BasicModal";
import { ModalSupportFooter } from "./ModalSupportFooter";

const OutOfServiceModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();

	useEffect(() => {
		logToSentry(`Out of service modal displayed on fridge: ${fridgeId}`, "info");
	}, [fridgeId]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant={"promoHeader"}>{t("modals.outOfService.title")}</ModalTitle>
			<Typography variant={"promoText"} sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.outOfService.description")}
			</Typography>
			<ErrorModalImage />
			<ModalSupportFooter fridgeId={fridgeId} />
		</ModalContentWrapper>
	);
};

export const OutOfServiceModal = () => {
	return (
		<BasicModal
			modalContent={<OutOfServiceModalContent />}
			open={true}
			closable={false}
			fullHeight={true}
		/>
	);
};
